import React from 'react';
import Slider from 'react-slick';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
import './CardCarousel.css';

function Arrow({ className, onClick, direction }) {
  const Icon = direction === 'previous' ? BsChevronLeft : BsChevronRight;
  return <button type="button" className={`${className || ''} set-card-carousel-arrow set-is-${direction}`} onClick={onClick} aria-label={`${direction === 'previous' ? 'Previous' : 'Next'} cards`}><Icon /></button>;
}

export default function CardCarousel({ children, className = '', variableWidth = false, cardWidth = 245, mobileCenter = false, mobileSlides = 2, desktopArrowThreshold = 3 }) {
  const cards = React.Children.toArray(children);
  if (!cards.length) return null;
  const settings = {
    dots: false,
    infinite: false,
    speed: 350,
    slidesToShow: variableWidth ? 1 : 3,
    slidesToScroll: 1,
    swipeToSlide: true,
    variableWidth,
    arrows: cards.length > desktopArrowThreshold,
    nextArrow: <Arrow direction="next" />,
    prevArrow: <Arrow direction="previous" />,
    responsive: variableWidth ? [
      { breakpoint: 768, settings: { centerMode: mobileCenter, centerPadding: '0px', infinite: mobileCenter && cards.length > 1, arrows: false } },
    ] : [
      { breakpoint: 768, settings: { slidesToShow: mobileSlides, arrows: cards.length > mobileSlides } },
    ],
  };
  return <div className={`set-card-carousel ${variableWidth ? 'set-is-variable' : ''} ${className}`}><Slider {...settings}>{cards.map((card, index) => <div className="set-card-carousel-slide" style={variableWidth ? { width: `${cardWidth}px` } : undefined} key={card.key || index}>{card}</div>)}</Slider></div>;
}
